<template>
  <!-- eslint-disable-next-line -->
  <svg class="icon" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 13H5v-2h14v2z"/></svg>
</template>

<style scoped>
.icon {
  display: inline;
  width: auto;
  height: 1em;
  vertical-align: -0.11em;
  fill: currentColor;
}
</style>
